module.exports = __webpack_public_path__ + "static/media/profil-mobile-pen.b592fcb4.svg";